<template>
  <div v-loading="loading">
    <el-dialog v-if="dialogVisibleMlytShow" v-el-drag-dialog :append-to-body="true" :close-on-click-modal="false" :title="'会议决议'" :visible.sync="dialogVisibleMlytShow" width="1000px">
      <div>
        <div v-if="voCopy.id" class="endTime">
          <span>会议决议标题：{{ curUserChoiceList[0].subject }}</span>
          <div>截止时间：{{ dellTime(voCopy.endTime) }}</div>
        </div>
        <template v-if="curUserChoiceList.length > 0">
          <div v-for="(item, index) in curUserChoiceList" :key="index" class="wt">
            <!-- 单选 -->
            <div class="wt1" style="min-height: 200px">
              <div class="wt3-2">
                <span>回答人数
                  {{ item.passenger.count ? item.passenger.count : 0 }}</span>
                <span>
                  <el-button
                    :key="item.id"
                    plain
                    :size="'small'"
                    style="padding: 6px 9px"
                    @click="exportdata1(item)"
                  >
                    <svg-icon
                      class="login-APPDownload-icon"
                      style="color: #f7caa0"
                      icon-class="export"
                    />
                    <span>导出</span>
                  </el-button>
                </span>
              </div>
              <div class="wt3-3" style="min-height: 300px; margin-top: 10px">
                <!-- {c}次</br> -->
                <div class="charts" style="width: 50%;min-height: 300px;height: 100%;background: #fbfbfc;border: 1px solid #e5e9ec;margin-right: 20px;padding: 15px;  ">
                  <EchartAnnular
                    style="min-height: 260px"
                    :chart-id="'Ech' + index"
                    :alldata="item.allData"
                    :radius="['0', '60%']"
                    :circle-center="['50%', '40%']"
                    :color="colorArr"
                    :formatter="'{b}:{d}%'"
                    :is-label="true"
                    :is-label-line="true"
                    :is-legend="true"
                    :legend-left="'center'"
                    :legend-top="'bottom'"
                    :legend-icon="'circle'"
                    :title="''"
                    :legend-formatter="legendFormatter"
                    :label-formatter="labelFormatter"
                  />
                </div>
                <el-table :id="item.id" :data="item.passenger.statistics" border style="width: 50%; margin: 0">
                <el-table-column :class-name="'cell'" label="选项" align="left" style="">
                    <template slot-scope="scope">
                        <span>{{
                          scope.row.choiceName
                        }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column :class-name="'cell'" prop="num" label="票数" width="100" align="center" />
                  <el-table-column :class-name="'cell'" prop="percentage" label="百分比" width="100" align="center" />
                </el-table>
              </div>
            </div>
          </div>
        </template>
        <div>
           <el-table :data="voteResultList" border style="width: 100%">
                <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
                <el-table-column prop="personName" label="姓名" align="left"></el-table-column>
                <el-table-column prop="deptName" label="所属部门" width="100" align="center"></el-table-column>
                <el-table-column prop="resultTime" label="投票时间" width="140" align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.resultTime | timeFormat }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="choiceName" label="投票结果" width="100" align="center"></el-table-column>
            </el-table>
        </div>
      </div>
     <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleMlytShow = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const qs = require('qs')
const moment = require('moment')
export default {
    components: {
    },
    filters: {
        timeFormat(val) {
            return moment(new Date(val)).format('YYYY-MM-DD HH:mm')
        }
    },
    props: {
        id: {
            type: String,
            default: function() {
                return ''
            }
        },
        type: {
            type: String,
            default: function() {
                return ''
            }
        },
        row: {
            type: Object,
            default: function() {
                return {}
            }
        }
    },
    data() {
        return {
            loading: false,
            dialogVisibleMlytShow: false,
            voCopy: {},
            voteTypeArr: ['单选', '多选'],
            voteResultList: [],
            tpList: [],
            base_api: process.env.VUE_APP_BASE_API,
            curUserChoiceList: [],
            colorArr: ['#379DD5', '#FFBD00', '#FF761B', '#91BD3C', '#2873C4', '#AD4200', '#636363', '#A27100', '#134578', '#A5A5A5'
            ],
            exportData: []
        }
    },
    computed: {},
    created() {
        this.$bus.on('openStatisticsVote', this.openStatisticsVote)
    },
    beforeDestroy() {
        this.$bus.off('openStatisticsVote', this.openStatisticsVote)
    },
    mounted() {
        // this.getVote()
    },
    methods: {
        exportdata1(row) {
            // 导出的表头
            const title = [
                { title: '序号', width: 60, align: 'center', colspan: 1, rowspan: 1 },
                {
                    title: '选项',
                    width: 150,
                    align: 'center',
                    colspan: 1,
                    rowspan: 1
                },
                {
                    title: '选择次数',
                    width: 150,
                    align: 'center',
                    colspan: 1,
                    rowspan: 1
                },
                {
                    title: '百分比',
                    width: 150,
                    align: 'center',
                    colspan: 1,
                    rowspan: 1
                }
            ]
            const tbtitle = []
            tbtitle.push(title)

            const tbdata = []
            // 数据处理
            row.passenger.statistics.forEach((list, listIndex) => {
                // 导出的值
                const row = [
                    { value: listIndex + 1, align: 'center', colspan: 1, rowspan: 1 },
                    { value: list.choiceName, align: 'center', colspan: 1, rowspan: 1 },
                    { value: list.num, align: 'center', colspan: 1, rowspan: 1 },
                    { value: list.percentage, align: 'center', colspan: 1, rowspan: 1 }
                ]
                tbdata.push(row)
            })

            // 发起请求---固定写法
            this.$http({
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                data: qs.stringify({
                    rows: JSON.stringify(tbdata),
                    titles: JSON.stringify(tbtitle),
                    fileName: row.subject
                }),
                url: 'common/exportXlsFile?httpPort=' + location.port
            }).then((res) => {
                if (res.code === 'success') {
                    var href = '/apigw/' + res.body.xlsurl
                    var tempLink = document.createElement('a') // 创建一个a标签
                    tempLink.style.display = 'none'
                    tempLink.href = encodeURI(href)
                    tempLink.setAttribute('download', row.subject + '.xls') // 给a标签添加下载属性
                    if (typeof tempLink.download === 'undefined') {
                        tempLink.setAttribute('target', '_blank')
                    }
                    document.body.appendChild(tempLink) // 将a标签添加到body当中
                    console.log('tempLink==', tempLink)
                    tempLink.click() // 启动下载
                    document.body.removeChild(tempLink) // 下载完毕删除a标签
                    href = ''
                } else {
                    this.$alert(res.message, '操作提示', { type: 'error' })
                }
            })
        },
        exportdata(row) {
            // 导出的表头
            const title = [
                { title: '序号', width: 60, align: 'center', colspan: 1, rowspan: 1 },
                {
                    title: row.subject,
                    width: 150,
                    align: 'center',
                    colspan: 1,
                    rowspan: 1
                }
            ]
            const tbtitle = []
            tbtitle.push(title)

            const tbdata = []
            // 数据处理
            row.passenger.statistics.forEach((list, listIndex) => {
                // 导出的值
                const row = [
                    { value: listIndex + 1, align: 'center', colspan: 1, rowspan: 1 },
                    { value: list.choiceName, align: 'center', colspan: 1, rowspan: 1 }
                ]
                tbdata.push(row)
            })

            // 发起请求---固定写法
            this.$http({
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                data: qs.stringify({
                    rows: JSON.stringify(tbdata),
                    titles: JSON.stringify(tbtitle),
                    fileName: row.subject
                }),
                url: 'common/exportXlsFile?httpPort=' + location.port
            }).then((res) => {
                if (res.code === 'success') {
                    var href = '/apigw/' + res.body.xlsurl
                    var tempLink = document.createElement('a') // 创建一个a标签
                    tempLink.style.display = 'none'
                    tempLink.href = encodeURI(href)
                    tempLink.setAttribute('download', row.subject + '.xls') // 给a标签添加下载属性
                    if (typeof tempLink.download === 'undefined') {
                        tempLink.setAttribute('target', '_blank')
                    }
                    document.body.appendChild(tempLink) // 将a标签添加到body当中
                    console.log('tempLink==', tempLink)
                    tempLink.click() // 启动下载
                    document.body.removeChild(tempLink) // 下载完毕删除a标签
                    href = ''
                } else {
                    this.$alert(res.message, '操作提示', { type: 'error' })
                }
            })
        },
        legendFormatter(name) {
            return name
        },
        labelFormatter(params) {
            return params.name + ':' + params.percent + '%'
        },
        openStatisticsVote(row) {
            this.loading = true
            this.row = row
            this.voCopy = row
            this.$http({
                method: 'GET',
                contentType: 'application/x-www-form-urlencoded',
                params: {
                    voteId: row.id
                },
                url: 'hygl/vote/queryVoterStatistics'
            }).then((res) => {
                if (res.code === 'success') {
                    this.voteStat()
                    this.curUserChoiceList = res.body.subjectList
                    this.curUserChoiceList.forEach((item, index) => {
                        item.allData = []
                        if (item.passenger.statistics.length > 0) {
                            item.passenger.statistics.forEach((list, listIndex) => {
                                const row = {
                                    value: list.num,
                                    name: list.choiceName
                                }
                                item.allData.push(row)
                            })
                        }
                    })
                    this.$emit('exportDataFmt', this.curUserChoiceList)
                    this.loading = false
                    this.dialogVisibleMlytShow = true
                } else {
                    this.$alert(res.message, '操作提示', { type: 'error' })
                    this.loading = false
                }
            })
        },
        /**
       * 查询主题投票人数
       */
        voteStat() {
            this.$http({
                method: 'get',
                params: {
                    voteId: `${this.row.id}`
                },
                url: 'hygl/voteResult/findResult'
            }).then((res) => {
                if (res.code === 'success') {
                    this.voteResultList = res.body.result || []
                } else {
                    this.$alert(res.message, '操作提示', { type: 'error' })
                }
            })
        },
        /**
     * 查询选项投票统计
     */
        queryStat() {
            this.$http({
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                params: {
                    themeId: this.id
                },
                url: 'znbg/voteResult/querydataByTheme'
            }).then((res) => {
                if (res.code === 'success') {
                    this.tpList = res.body.listdata
                    this.voCopy.passenger['subjects'].forEach((item, i) => {
                        item.voteNum = 0
                        item.passenger['choices'].forEach((choice, i) => {
                            choice.voteNum = this.tpList[item.subject][choice.subject]
                            // 计算每道题目总的票数
                            item.voteNum += choice.voteNum
                        })
                    })
                    setTimeout(() => {
                        this.voCopy.passenger['subjects'].forEach((item, i) => {
                            item.passenger['choices'].forEach((choice, j) => {
                                // 保证所有百分比加起来为1
                                if (j === item.passenger['choices'].length - 1) {
                                    this.getPer(j, item)
                                } else {
                                    if (choice.voteNum > 0) {
                                        choice.votePercent = Math.round(
                                            (choice.voteNum / item.voteNum) * 100
                                        )
                                    } else {
                                        choice.votePercent = 0
                                    }
                                }
                                $('#' + choice.id + '.tpprocess').width(
                                    choice.votePercent + '%'
                                )
                            })
                        })
                        this.exportDataFmt(this.voCopy.passenger['subjects'])
                        this.$forceUpdate()
                    }, 0)
                    this.$forceUpdate()
                }
            })
        },
        /**
     * 递归计算最后一个选项的百分比，保证所有选项百分比之和为1
     */
        getPer(m, item) {
            if (item.passenger['choices'][m]['voteNum'] > 0) {
                var temp = 100
                for (var k = 0; k < m; k++) {
                    temp -= item.passenger['choices'][k]['votePercent']
                }
                item.passenger['choices'][m]['votePercent'] = temp
            } else {
                item.passenger['choices'][m]['votePercent'] = 0
                if (m > 0) {
                    this.getPer(m - 1, item)
                }
            }
        },
        exportDataFmt(data) {
            // data.forEach((item, index) => {
            //     item.voteNum = 0
            //     this.exportData.push(item.subject + '(' + this.voteTypeArr[item.voteType - 1] + ')')
            //     item.passenger['choices'].forEach((choice, _index) => {
            //         this.exportData.push(choice.voteNum + '票' + ' ' + choice.votePercent + '%')
            //         item.voteNum += choice.voteNum
            //     })
            //     this.exportData.push('合计：' + item.voteNum)
            // })
            // this.$emit('exportDataFmt', this.exportData)
            this.$emit('exportDataFmt', data)
        },
        dellTime(time) {
            return moment(new Date(time)).format('YYYY-MM-DD HH:mm')
        }
    }
}
</script>

<style scoped lang="scss">
ul {
  list-style-type: none;
  padding: 0;
}
.endTime {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
  line-height: 40px;
  font-size: 1.1em;
}
.voteInfo {
  border: 1px solid #e0e0e0;
  border-bottom: none;
  margin: 0 0 20px;
  li {
    border-bottom: 1px solid #e0e0e0;
    line-height: 40px;
    padding-left: 10px;
    padding-right: 10px;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    position: relative;
    .tpprocess {
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      background: #c4e0ff;
      z-index: 1;
    }
  }
  .choices {
    display: flex;
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
}
.title {
  font-size: 14px;
  font-weight: bold;
  color: #333;
}
.progress-box {
  padding-bottom: 19px;
  width: calc(100% - 50px);
}
.num {
  position: relative;
  width: 50px;
  span {
    width: 50px;
    position: absolute;
    bottom: 19px;
    line-height: 1;
    text-align: center;
  }
}
.fr {
  width: 50px;
  text-align: center;
}
.all-box {
  padding-left: 20px !important;
  padding-right: 20px !important;
}

.wt {
  margin-bottom: 20px;
}

.wt1 {
  .wt3-1 {
    font-size: 13px;
    color: #333;
  }
  .wt3-2 {
    margin-top: 5px;
    font-size: 13px;
    color: #999;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .wt3-3 {
    display: flex;
    align-items: flex-start;
  }
}
.wt2 {
  .wt3-1 {
    font-size: 13px;
    color: #333;
  }
  .wt3-2 {
    margin-top: 5px;
    font-size: 13px;
    color: #999;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .wt3-3 {
    display: flex;
    align-items: flex-start;
  }
}
.wt3 {
  .wt3-1 {
    font-size: 13px;
    color: #333;
  }
  .wt3-2 {
    height: 40px;
    font-size: 13px;
    color: #999;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .wt3-3 {
  }
}

/deep/ .el-table .cell {
  padding: 5px 5px !important;
}
</style>
